/**
 * נתיבי URL לזרימת טיסות תחת /p/dashboard/searchoffer/...
 * מקטע אחד אחרי .../flights/:flightStep
 */

/**
 * רשימת תוצאות טיסות בדשבורד הסוכן — זיהוי חייב להיות עקבי גם כש־basename/pathname מול RR לא תואמים,
 * אחרת FlightWizardShell נשאר ב־searchPhase וכל תוכן הוויזארד ב־display:none.
 *
 * @param {string} [routerPathname] useLocation().pathname (יחסי ל-basename אם קיים)
 * @param {string|undefined} flightStep מ־useParams().flightStep
 */
export function isAgentFlightResultsListUrl(routerPathname, flightStep) {
  if (flightStep === "results") return true;
  const r = typeof routerPathname === "string" ? routerPathname : "";
  if (r.includes("/flights/results")) return true;
  if (typeof window !== "undefined") {
    const w = window.location.pathname || "";
    if (w.includes("/flights/results")) return true;
  }
  return false;
}

const STEP_TO_SEGMENT = {
  search: null,
  results: "results",
  selfComposePick: "self-compose",
  flightDetails: "details",
  extras: "extras",
  passengers: "passengers",
  review: "review",
  holdConfirmation: "hold",
  draftPayment: "payment",
  success: "success",
};

/** @param {string} segment */
export function bookingStepFromFlightUrlSegment(segment) {
  if (!segment || typeof segment !== "string") return null;
  const entry = Object.entries(STEP_TO_SEGMENT).find(([, v]) => v === segment);
  return entry ? entry[0] : null;
}

/** @param {string} step */
export function flightUrlSegmentFromBookingStep(step) {
  return STEP_TO_SEGMENT[step] ?? null;
}

/**
 * @param {Record<string, string | undefined>} params useParams() מ־React Router
 * @returns {string} נתיב מלא מ־/p/dashboard
 */
export function buildSearchOfferDashboardPath(params) {
  const { selectedPackageId, dynamicOrderId, hotelOrderId } = params || {};
  if (selectedPackageId && hotelOrderId) {
    return `/p/dashboard/searchoffer/${selectedPackageId}/hotel/${hotelOrderId}`;
  }
  if (selectedPackageId && dynamicOrderId) {
    return `/p/dashboard/searchoffer/${selectedPackageId}/dynamic/${dynamicOrderId}`;
  }
  if (selectedPackageId) {
    return `/p/dashboard/searchoffer/${selectedPackageId}`;
  }
  return `/p/dashboard/searchoffer`;
}

/**
 * @param {Record<string, string | undefined>} params
 * @param {string} currentStep
 */
export function buildFlightFlowDashboardPath(params, currentStep) {
  const base = buildSearchOfferDashboardPath(params);
  const seg = flightUrlSegmentFromBookingStep(currentStep);
  if (!seg) return base;
  return `${base}/flights/${seg}`;
}

/**
 * גלילה לראש בעת מעבר בין שלבי ‎.../flights/:step‎ בדשבורד.
 * יש כמה אזורי גלילה מקוננים (agent-pages, agent-component, עמודת תוצאות וכו׳).
 */
/** לוג DEV לניווט חזרה לקטגוריות מזרימת טיסות ב-searchoffer */
export function logFlightsBackToCategoriesNavigation(payload) {
  if (!import.meta.env.DEV) return;
  console.log("[FLIGHTS_BACK_TO_CATEGORIES_NAVIGATION]", payload);
}

function resetOverflowAncestorScroll(anchorEl) {
  let node = anchorEl;
  while (node && node !== document.documentElement && node !== document.body) {
    if (typeof node.scrollTop === "number" && node.scrollTop !== 0) {
      node.scrollTop = 0;
    }
    node = node.parentElement;
  }
}

/**
 * @param {Element | null} [anchorEl] optional node inside the scrolled pane
 *   (e.g. self-compose heading) — also resets overflow ancestors that the
 *   hardcoded selectors might miss.
 */
export function scrollSearchOfferFlightFlowToTop(anchorEl) {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;

  const selectors = [
    ".agent-pages",
    ".agent-component",
    ".price-offer-f-h-wrapper",
    ".price-offer-page-container",
    ".price-offer-flight-booking-mockup-host",
    ".fw-root",
    ".fw-main",
  ];
  for (const sel of selectors) {
    document.querySelectorAll(sel).forEach((el) => {
      el.scrollTop = 0;
    });
  }

  if (anchorEl && typeof anchorEl === "object") {
    resetOverflowAncestorScroll(anchorEl);
  }
}
